import { useEffect, useState } from 'react';
import axios from 'axios';
import '../home/styles.scss';
import 'react-loading-skeleton/dist/skeleton.css'
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";


import { Fade } from "react-awesome-reveal";
import { HomeBanner } from '../../components/home/Banner';
import { PracticeAreasSection } from '../../components/home/PracticeAreasSection';
import { TestimonialSection } from '../../components/home/TestimonialSection';
import { ContactSection } from '../../components/home/ContactSection';
import PageLoader from '../../components/global/loader/PageLoader';
import { AboutUsSection } from '../../components/home/AboutUsSection';
import { OurDifferenceSection } from '../../components/home/OurDifferenceSection';

const Home = () => {
    const [fields, setFields] = useState([]);
    const [latestBlogs, setLatestBlogs] = useState([]);
    const [isFetchingPageData, setIsFetchingPageData] = useState(true);
    useEffect(() => {
        document.body.classList.add('home');
        fetchHomeData();
        if (document.querySelector('#wp-admin-bar-edit a')) {
            document.querySelector('#wp-admin-bar-edit a').innerText = `Edit Page`;
            document.querySelector('#wp-admin-bar-edit a').href = `/wp-admin/post.php?post=73&action=edit`;
        }
        // document.body.classList.remove('home');
        // document.title = 'Alinea Law PLLC';
        return () => {
            document.body.classList.remove('home');
        }
    }, []);



    const fetchHomeData = async () => {
        setIsFetchingPageData(true);
        try {
            const { data } = await axios.get(`/wp-admin/admin-ajax.php?action=get_pages_by_page_name&page_name=home`);
            console.log(data)
            setFields(data?.fields ?? []);
            setLatestBlogs(data?.latest_blogs ?? []);
            if (data?.yoast_title?.length > 0) {
                const finalTitle = data.yoast_title
                    .replace("%%title%%", data?.page?.post_title ? data?.page?.post_title : '')
                    .replace("%%page%%", "")
                    .replace("%%sep%%", " - ")
                    .replace("%%sitename%%", "Alinea Law PLLC")

                document.title = finalTitle;
            } else {
                document.title = data?.page?.post_title ? `${data?.page?.post_title} - Alinea Law PLLC` : "Alinea Law PLLC";
            }
        } catch (err) {
            console.log(err);
        } finally {
            setIsFetchingPageData(false);
        }
    }

    useEffect(() => {
        if (isFetchingPageData) {
            document.body.classList.add('is-page-loading');
        } else {
            document.body.classList.remove('is-page-loading');
        }
    }, [isFetchingPageData]);



    return <Fade delay={1}>
        <main id="main" className="home">
            {!isFetchingPageData && <>
                <HomeBanner fields={fields} />
                <AboutUsSection fields={fields} />
                <PracticeAreasSection fields={fields} />
                <OurDifferenceSection fields={fields} />
                <TestimonialSection fields={fields} />
                <ContactSection />
            </>}

            {isFetchingPageData && <>
                <PageLoader />
            </>}
        </main>
    </Fade>
}

export default Home;